<template id="personal_center">
	<div>
		<div class="col-md-12 pr-0 pl-0 centre_sm_none">
			<div class="accountManage">
				<p class="account_manage_title">My contribution</p>
                <div class="addBtn"><img src="../../../assets/images/silkRoadBase/add_share.png" alt="">
                    <span @click="gotoAdd()">My articles</span>
                </div>
				<ul class="nav nav-tabs" role="tablist">
                    <li role="presentation" class="account_manage_title_active">
                        <a href="javascript:" @click="contributetab(msga=6)" :class="{'text-primary':msga===6}">All</a>
                    </li>
					<!--<li role="presentation" class="account_manage_title_active">-->
						<!--<a href="javascript:;" @click="contributetab(msga=0)"  :class="{'text-primary':msga===0}">投稿</a>-->
					<!--</li>-->
					<li role="presentation" class="account_manage_title_active">
						<a href="javascript:" @click="contributetab(msga=1)" :class="{'text-primary':msga===1}">Under Review</a>
					</li>
					<li role="presentation" class="account_manage_title_active">
						<a href="javascript:" @click="contributetab(msga=2)" :class="{'text-primary':msga===2}">Reviewed</a>
					</li>
                    <li role="presentation" class="account_manage_title_active">
                        <a href="javascript:" @click="contributetab(msga=5)" :class="{'text-primary':msga===5}">Drafted</a>
                    </li>
					<li role="presentation" class="account_manage_title_active">
						<a href="javascript:" @click="contributetab(msga=3)" :class="{'text-primary':msga===3}">Rejected</a>
					</li>
					<li role="presentation" class="account_manage_title_active">
						<a href="javascript:" @click="contributetab(msga=4)" :class="{'text-primary':msga===4}">Drafts</a>
					</li>
				</ul>

				<div class="tab-content">
					<div class="nano video_breviary" id="accountSettings">
						<div class="nano-content" id="home_right_list">
                            <ul class="buteList clearfix">
                                <li class="col-md-3 col-lg-3 col-sm-4 listItem col-gg-2" v-for="item in list" @click="gotoDetail(item.id)">
                                    <div class="itemCont">
                                    <div class="listTop">
                                        <img :src="item.thumb" class="account_portrait"  style="border-radius:0px!important;"/>
                                        <div class="topCover"><span v-if="item.status ==1">Under Review</span><span v-if="item.status ==2 && !item.contentid">Reviewed</span><span v-if="item.status ==2 && item.contentid">Drafted</span><span v-if="item.status ==3">Rejected</span><span v-if="item.status ==4">Drafts</span></div>
                                    </div>
                                    <p class="Itemcontent two_ell">{{item.title}}</p>
                                    <p class="ItemTime" v-if="item.status ==2 && item.contentid"><span>{{item.category}}</span><span>{{item.published}}</span></p>
                                    <div class="listBottom">
                                        <div class="bottomLeft col-md-6">

                                            <span v-if="item.status == 1 | item.status == 3 | item.status == 4" @click.stop.prevent="gotoEdit(item.id)" style="margin-left:-10px;">Edit</span>
                                            <span @click.stop.prevent="deleteContrbute(item.id)"  v-if="item.status == 1 | item.status == 3 | item.status == 4">Delete</span>
                                        </div>
                                        <p class="col-md-6" v-if="item.status ==1" style="color:#F5A623">Under Review</p>
                                        <p class="col-md-6" v-if="item.status ==2 && !item.contentid" style="color:#208EFF">Reviewed</p>
                                        <p class="col-md-6" v-if="item.status ==2 && item.contentid" style="color:#208EFF">Drafted</p>
                                        <p class="col-md-6" v-if="item.status ==3" style="color:#FC5D4D">Rejected</p>
                                        <p class="col-md-6" v-if="item.status ==4" style="color:#8590A6">Drafts</p>
                                    </div>
                                    </div>
                                </li>
                            </ul>
                            <div v-if="list.length ==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="" />
                            <p class="text-center p-2">loading</p>
                            </div>
						</div>
					</div>

				</div>
			</div>
		</div>

        <!--删除确认框-->
        <div class="mask col-md-5" v-show='maskShow'>
            <img src="../../../assets/images/silkRoadBase/fail.png" alt="" />
            <p>Sure to delete?</p>
            <div class="btnGroup">
                <span @click="del()">Yes</span>
                <span @click="cancel()">Cancel</span>
            </div>
        </div>

	</div>
</template>
<script>
	export default({
		name: 'contribute',
		data: function() {
			return {
				editor: null,
				editors:null,
				editores:null,
				msga:6,
                list: [],
                current_page: 1,
                page_size: 8,
                total_page: 1,
                maskShow:false,
                del_id: ''
			}
		},
		created: function() {
            this.getList();
		},

		methods: {
            contributetab(){
              this.current_page = 1;
              this.getList();
            },
		    getList(){
                var self = this;
                var param = {
                    'typeid' : self.msga,
                    'current_page' : self.current_page,
                    'page_size' : self.page_size
                };
                this.$axios.post('/api/pc/contributelist', param).then(data => {
                    if (data.data.state) {
                        self.list = data.data.data.data;
                        self.total_page=Math.ceil(data.data.data.total/self.page_size);
                    }
                })
            },
            gotoAdd(){
                this.$router.push({path:'contribute/contributeAdd'});
            },
            gotoEdit(id){
                this.$router.push({path:'contribute/contributeAdd/' + id });
            },
            gotoDetail(id){
                this.$router.push({path:'contribute/contributeEdit/' + id});
            },
            // 删除按钮弹窗
            deleteContrbute(id){
                this.del_id = id;
                this.maskShow = true;
            },
            del(){
                this.$axios.post('/api/pc/delcontribute',{id:this.del_id}).then(data => {
                    if (data.data.state) {
                        this.maskShow = false;
                        this.current_page = 1
                        this.getList();
                    }
                })
            },
            cancel(){
                this.maskShow = false;
            },
            handleScroll() {
                var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_right_list').scrollHeight; // 总高度
                var self = this;
                if((all - 20) < (top + client)) {
                    self.current_page++;
                    if(self.current_page > self.total_page) {
                        return;
                    }
                    var param = {
                        'typeid' : self.msga,
                        'current_page' : self.current_page,
                        'page_size' : self.page_size
                    };
                    this.$axios.post('/api/pc/contributelist', param).then(data => {
                        var homeListes = data.data.data.data;
                        JSON.stringify(homeListes);
                        var new_homeLists = self.list.concat(homeListes);
                        self.list = new_homeLists;
                    })
                }

            },

		},
		mounted() {
            document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			this.load();
		},
		computed:{

		}

	})
</script>
<style scoped type="text/css">
    .accountManage{
        position: relative;
    }
    .addBtn{
        position: absolute;
        right: 40px;
        top: 20px;
    }
    .addBtn:hover{
        cursor: pointer;
    }
    .addBtn img{
        width:17px;
        height: 17px;
        vertical-align: middle;
    }
    .addBtn span{
        font-size:15px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(38,38,38,1);
        line-height:21px;
        margin-left:2px;
    }
    .listItem{
        margin-top:30px;
        float:left;
    }
    .listItem:hover{
        cursor:pointer;
    }
    .itemCont{
        /*height:303px;*/
        background:rgba(255,255,255,1);
        border:1px solid rgba(241,241,241,1);
    }
    .two_ell {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .buteList {
       padding-left:15px
    }
    .listTop{
        position:relative;
    }
    .listTop img{
        width: 100%;
        height: 158px;
    }
    .listTop .topCover{
        text-align: center;
        height:30px;
        bottom: 0;
        width: 100%;
        background:rgba(0,0,0,1);
        opacity:0.6;
        position: absolute;
        font-size:12px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:30px;
    }
    .Itemcontent{
        height:40px;
        padding: 15px;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(38,38,38,1);
        line-height:20px;
    }
    .ItemTime{
        height:17px;
        padding: 15px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:17px;
    }
    .listBottom{
        display: flex;
        justify-content: space-between;
        border-top:1px solid #F1F1F1;
    }
    .bottomLeft{
        display: flex;
        justify-content: space-around;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        height: 47px;

        padding: 15px;
        line-height: 17px;
        color:rgba(133,144,166,1);
    }
    .bottomLeft span:hover{
        /*display:inline-block;*/
        cursor:pointer;
    }
    .listBottom p{
        text-align: right;
        line-height: 47px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
    }
    .mask{
        position: absolute;
        left: 0px;
        height:259px;
        width:433px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
        border-radius:2px;
        right: 0px;
        bottom: 0px;
        padding:32px 78px 48px;
        top: 0px;
        margin: auto;
        text-align:center;
        z-index:9999;
    }
    .mask p{
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:600;
        color:rgba(0,0,0,1);
        line-height:25px;
        margin-top:20px!important;
    }
    .btnGroup{
        margin-top: 48px;
        display: flex;
        justify-content: space-between;
    }
    .btnGroup span:nth-child(2){
        background:rgba(242,243,244,1);
        color:#8590A6;
    }
    .mask span{
        width:126px;
        height:32px;
        background:rgba(32,142,255,1);
        border-radius:16px;
        display:block;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:32px;
    }
    .mask span:hover{
        cursor: pointer;
    }
    @media screen and (max-width: 1024px) {
        .listItem {
            -ms-flex: 0 0 33.33333%;
            flex: 0 0 33.33333%;
            max-width: 33.33333%;
        }
        .mask{
            padding:32px 58px 48px;
        }
    }
    @media screen and (max-width: 700px) {
        .mask{
            padding:32px 38px 48px;
        }
    }
    @media screen and (max-width: 544px) {
        .listItem {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }
        .listTop img{
            height:auto
        }
        @media screen and (min-width: 1600px){
            col-gg-2{
                flex: 0 0 20%;
                max-width: 20%;
            }
        }
        @media screen and (min-width: 1920px){
            col-gg-2{
                flex: 0 0 16.6666666%;
                max-width: 16.66666%;
            }
        }
    }
</style>
